<template>
   <v-dialog name="editRow" v-model="level.dialogValues.dialogShow.exchange" data-app="true" persistent max-width="900">
      <v-card>

       <CardUpdatableHeader :row="row" :level="level"/>

        <v-card-text>
          <v-container>
            <v-row>
            </v-row>
            <v-row>
              <v-col v-if="!level.dialogValues.form_create" cols="12">
                <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.shc_create,'long') }}<br/>
                <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.shc_create,'long') }}
              </v-col>
            </v-row>
         </v-container>
          <small>*{{ $t('texts.requiredfield') }}</small>
        </v-card-text>

        <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
   </v-dialog>
</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelect from '@/components/ddoSelect.vue';

export default {
   name: 'CardUpdatableCUSPLFEXCHANGE',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoSelect,
   },
   props: {
   },
   data: function () {
      return {
      }
   },
}
</script>